<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/courses']"  [queryParams]="{tab:tab}"><img
            src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-4">
            <h2 *ngIf="!this.type">Create Course</h2>
            <h2 *ngIf="this.type">Edit Course</h2>
            <p>Please add the following information to create a new course</p>
        </div>
        <!-- <div class="col-12 col-md-4">
    <div class="filterWrap">
        <div class="searchWrap mr-0">
            <input type="text" placeholder="Search Users">
        </div>
    </div>
</div>
<div class="col-12 col-md-4">
    <div class="filterSelect">
        <span>Filter by Organisation:</span>
        <div class="selectCustom">
            <select>
                <option>All</option>
                <option>Select 02</option>
                <option>Select 03</option>
            </select>
        </div>
    </div>
</div> -->
    </div>
</div>
<div class="sttperWrap">
    <div class="sttperHead">
        <ul>
            <li>
                <a href="javascript:void(0);" class="active"><b>01</b>Course
                    Details</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="events-none"><b>02</b>Add
                    Modules</a>
            </li>
            <li>
                <a href="javascript:void(0);" class="events-none"
                    [routerLink]="['/courses_add_review']"><b>03</b>Review</a>
            </li>
            <li *ngIf="!type">
                <a href="javascript:void(0);" class="events-none"
                    [routerLink]="['/courses_add_assign_user']"><b>04</b>Assign Users</a>
            </li>
        </ul>
    </div>
    <form [formGroup]="courseForm">
        <div class="sttperBody mt-5">
            <div class="uploadImageWrap">
                <figure *ngIf="imageSrc ==''">
                    <img src="assets/images/admin/placeholder.png" />
                </figure>
                <figure *ngIf="imageSrc !=''">
                    <img [src]="imageSrc" />
                </figure>

                <div class="uploadImage">
                    <span>Upload Picture</span>
                    <input type="file"  (change)="onFileChange($event)"/>
                    <div *ngIf="submitted && f.course_image.errors">
                        <span *ngIf="f.course_image.errors.required" class="text-mute text-danger errorText">This field
                            is required</span>
                    </div>
                </div>
            </div>
            <div class="formAreaAdmin">
                <div class="row m-0">
                    <div class="col-6">
                        <div class="commanInput">
                            <mat-form-field class="example-full-width">
                                <mat-label>Course Name</mat-label>
                                <input matInput #courseName maxlength="100" placeholder="Enter Name"
                                    formControlName="course_name"
                                    [ngClass]="{ 'is-invalid': submitted && f.course_name.errors }" autocomplete="off" (change)="autoSave()">
                                <mat-hint align="end">{{courseName.value.length}} / 100 characters</mat-hint>
                            </mat-form-field>
                            <div *ngIf="submitted && f.course_name.errors">
                                <span *ngIf="f.course_name.errors.required" class="text-mute text-danger errorText">This
                                    field is required</span>
                            </div>
                        </div>

                        <div class="commanInput">
                            <mat-form-field class="example-full-width" (click)="picker.open()">
                                <mat-label>Last date (MM/DD/YYYY)</mat-label>
                                <input matInput [min]="minDate" #endDate [matDatepicker]="picker"
                                    placeholder="Select Date" formControlName="end_date"
                                    [ngClass]="{ 'is-invalid': submitted && f.end_date.errors }" [readonly]=true (change)="autoSave()">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                            <div *ngIf="submitted && f.end_date.errors && statusError !=2 ">
                                <span *ngIf="f.end_date.errors.required" class="text-mute text-danger errorText">This
                                    field is required</span>
                            </div>
                        </div>

                    </div>
                    <div class="col-6">
                        <div class="commanInput commanTextarea">
                            <mat-form-field class="example-full-width">
                                <mat-label>Course Description</mat-label>
                                <textarea matInput #courseDesc maxlength="250" placeholder="Enter Description"
                                    formControlName="course_desc"
                                    [ngClass]="{ 'is-invalid': submitted && f.course_desc.errors }" (change)="autoSave()"></textarea>
                                <mat-hint align="end">{{courseDesc.value.length}} / 250</mat-hint>
                            </mat-form-field>
                            <div *ngIf="submitted && f.course_desc.errors && statusError != 2">
                                <span *ngIf="f.course_desc.errors.required" class="text-mute text-danger errorText">This
                                    field is required</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <ngx-spinner>
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="sttperFooter">
        <div class="row m-0">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(cancel)">Cancel</a>
            <div class="ml-auto">
                <a *ngIf="!type" href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" [ngClass]=" (courseName.value.length < 1) ? 'btn btn-primary btn-sm btn-border ml-1 mr-1 disableborder ' :
         'btn btn-primary btn-sm btn-border ml-1 mr-1' " (click)="createCourses('1',2)"><span>Save as Draft</span></a>
                <a *ngIf="!type" href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" [ngClass]="(courseName.value.length < 1 || courseDesc.value.length < 1 || endDate.value.length < 1) ? 'btn btn-primary btn-sm ml-2 mr-2 disable ' :
         'btn btn-primary btn-sm ml-2 mr-2' " (click)="createCourses('1',0)">Save & Next</a>
         <a *ngIf="type" href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" [ngClass]="(courseName.value.length < 1 || courseDesc.value.length < 1 || endDate.value.length < 1) ? 'btn btn-primary btn-sm ml-2 mr-2 disable ' :
         'btn btn-primary btn-sm ml-2 mr-2' " (click)="createCourses('2',0)">Save & Next</a>
            </div>
        </div>
    </div>
</div>
<!-- <ng-template #cancelbk let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Back to course list</h6>
                <p class="size18">Are you sure you would like to back to course list?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="cancelbkCourse()">Confirm</a>
            </div>
        </div>
    </div>
</ng-template> -->
<ng-template #cancel let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Cancel Course</h6>
                <p class="size18">Are you sure you would like to Cancel Course?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="cancelCourse()">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
